import React from "react";

const Loader = () => {
  return <div style={{ width: "100%" }}></div>;
};

export default Loader;
